export default {
  OWNER: 'OWNER',
  INVITEE: 'INVITEE',
  BROKER: 'BROKER'
};
